export const safeToLowerCase = (value) => {
  if (!value) return '';
  return String(value).toLowerCase();
};